import { jsx } from 'react/jsx-runtime';
import { Box } from '../Box/Box.js';
import { Typography } from '../Typography/Typography.js';

const CardTimer = ({ children, ...props }) => (jsx(Box, { as: "time", background: "neutral800", bottom: 1, right: 1, color: "neutral0", hasRadius: true, position: "absolute", padding: 1, ...props, children: jsx(Typography, { variant: "pi", textColor: "neutral0", children: children }) }));

export { CardTimer };
